export function loggedIn(state) {
  return state.token !== null;
}
export function token(state) {
  return state.token;
}

export function currentLanguage(state) {
  return state.language;
}

export function currentTranslations(state) {
  return state.translations[state.language]
}
